import { render } from "./HealthcareHome.vue?vue&type=template&id=5523f768&scoped=true"
import script from "./HealthcareHome.vue?vue&type=script&lang=js"
export * from "./HealthcareHome.vue?vue&type=script&lang=js"

import "./HealthcareHome.vue?vue&type=style&index=0&id=5523f768&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5523f768"]])

export default __exports__